var exports = {
  "iU": "Message.module__message___T0ZGY0",
  "Ph": "Message.module__messagePreviewSpacing___T0ZGY0",
  "IL": "Message.module__messagePreview___T0ZGY0",
  "Xo": "Message.module__messageHovered___T0ZGY0",
  "uK": "Message.module__focusRingAnchor___T0ZGY0",
  "J8": "Message.module__messageCompact___T0ZGY0",
  "L8": "Message.module__messageMentioned___T0ZGY0",
  "m6": "Message.module__messageReplying___T0ZGY0",
  "O6": "Message.module__messageHighlight___T0ZGY0",
  "lY": "Message.module__contextMenuActive___T0ZGY0",
  "Bc": "Message.module__mobileLayout___T0ZGY0",
  "p2": "Message.module__messageLongPress___T0ZGY0",
  "Uw": "Message.module__messageGrouped___T0ZGY0",
  "kT": "Message.module__messageEditing___T0ZGY0",
  "E4": "Message.module__messageSent___T0ZGY0",
  "mr": "Message.module__messageSending___T0ZGY0",
  "b$": "Message.module__messageFailed___T0ZGY0",
  "RZ": "Message.module__failedFooter___T0ZGY0",
  "Iu": "Message.module__failedFooterMessage___T0ZGY0",
  "bg": "Message.module__failedFooterLabel___T0ZGY0",
  "OZ": "Message.module__failedFooterIcon___T0ZGY0",
  "dv": "Message.module__failedRetryIcon___T0ZGY0",
  "QW": "Message.module__failedRetryButton___T0ZGY0",
  "q5": "Message.module__messageGutterLeft___T0ZGY0",
  "ZN": "Message.module__messageGutterRight___T0ZGY0",
  "$7": "Message.module__messageAvatar___T0ZGY0",
  "CW": "Message.module__messageNoText___T0ZGY0",
  "U7": "Message.module__messageContent___T0ZGY0",
  "rO": "Message.module__messageAuthorInfo___T0ZGY0",
  "xW": "Message.module__jumpHeading___T0ZGY0",
  "RO": "Message.module__jumpHeadingButton___T0ZGY0",
  "dw": "Message.module__messageAuthorRow___T0ZGY0",
  "um": "Message.module__messageUsername___T0ZGY0",
  "Lo": "Message.module__messageText___T0ZGY0",
  "AY": "Message.module__messageAuthorPart___T0ZGY0",
  "oL": "Message.module__messageTimestamp___T0ZGY0",
  "L5": "Message.module__messageTimestampCompact___T0ZGY0",
  "tQ": "Message.module__compactAuthorPrefix___T0ZGY0",
  "U6": "Message.module__copyOnly___T0ZGY0",
  "Mz": "Message.module__compactInlineContent___T0ZGY0",
  "aM": "Message.module__systemMessageContent___T0ZGY0",
  "vp": "Message.module__contextMenuUnderline___T0ZGY0",
  "aE": "Message.module__messageTimeoutIndicator___T0ZGY0",
  "t4": "Message.module__textSeparator___T0ZGY0",
  "BK": "Message.module__authorDashSeparator___T0ZGY0",
  "KL": "Message.module__messageTimestampHover___T0ZGY0",
  "jh": "Message.module__messageTimestampCompactHover___T0ZGY0",
  "iZ": "Message.module__messageAvatarCompact___T0ZGY0",
  "kq": "Message.module__compactContentWrapper___T0ZGY0",
  "xv": "Message.module__hoverAction___T0ZGY0",
  "kL": "Message.module__container___T0ZGY0",
  "tI": "Message.module__repliedMessage___T0ZGY0",
  "_T": "Message.module__repliedMessageCompact___T0ZGY0",
  "$y": "Message.module__repliedTextPreview___T0ZGY0",
  "NL": "Message.module__repliedAvatar___T0ZGY0",
  "a3": "Message.module__repliedIconContainer___T0ZGY0",
  "Pq": "Message.module__repliedIcon___T0ZGY0",
  "EK": "Message.module__repliedUsername___T0ZGY0",
  "IQ": "Message.module__repliedItalic___T0ZGY0",
  "Mx": "Message.module__unstyled___T0ZGY0",
  "Io": "Message.module__repliedTextContent___T0ZGY0",
  "c": "Message.module__systemMessageFollowsSystem___T0ZGY0",
  "Hj": "Message.module__systemMessageIconWrapper___T0ZGY0",
  "Po": "Message.module__systemMessageIconCompact___T0ZGY0",
  "jJ": "Message.module__systemMessageTimestamp___T0ZGY0",
  "rc": "Message.module__systemMessageContentWrapper___T0ZGY0",
  "V_": "Message.module__systemMessageCompactContent___T0ZGY0",
  "Gq": "Message.module__systemMessageIconSvg___T0ZGY0",
  "hr": "Message.module__systemMessageLink___T0ZGY0",
  "x": "Message.module__userTagOffset___T0ZGY0",
  "ll": "Message.module__userTagCompact___T0ZGY0",
  "O4": "Message.module__editedTimestamp___T0ZGY0",
  "k8": "Message.module__editedLabel___T0ZGY0",
  "zX": "Message.module__typingContainer___T0ZGY0",
  "Y9": "Message.module__typingCluster___T0ZGY0",
  "RL": "Message.module__typingIndicator___T0ZGY0",
  "Kl": "Message.module__typingAvatarContainer___T0ZGY0",
  "tY": "Message.module__typingText___T0ZGY0",
  "AZ": "Message.module__typingClusterComposerStatus___T0ZGY0",
  "am": "Message.module__compactContentNoPrefix___T0ZGY0",
  "Ys": "Message.module__compactBody___T0ZGY0",
  "Ac": "Message.module__unknownMessageCompactContent___T0ZGY0",
  "qU": "Message.module__unknownMessageWarning___T0ZGY0",
  "NG": "Message.module__keyboardFocused___T0ZGY0",
  "an": "Message.module__messageClientSystem___T0ZGY0",
  "og": "Message.module__systemMessageContainer___T0ZGY0",
  "Is": "Message.module__systemMessageIcon___T0ZGY0",
  "ry": "Message.module__mediaFocusRing___T0ZGY0",
  "xS": "Message.module__systemMessageDismissButton___T0ZGY0",
  "Eu": "Message.module__silentMessageIcon___T0ZGY0",
};

module.exports = exports;
